import axiosClient from "./axios";

/**
 * Kullanıcının olumlama geçmişini getirir
 * @param {number} days - Kaç günlük geçmiş getirilecek (varsayılan: 7)
 * @returns {Promise} Olumlama geçmişi verisi
 */
export const getAffirmationsHistory = async (days = 7) => {
  try {
    const response = await axiosClient.get(`/module/affirmations/history?days=${days}`);
    return response.data;
  } catch (error) {
    console.error("Olumlama geçmişi alınırken hata:", error);
    throw error;
  }
};

